import API from "api/API";
import useFetchData from "hooks/useFetchData";

export default function useUDGroups( name ) {
   return useFetchData({
      APIMethod: API.getUDGroups,
      condition: !!name,
      params: [ name ],
      cache_name: name + "-ud-groups",
      resultDataHandler: data => data.map( g => ({
         value: g.id,
         label: g.name,
         table_header: g.table_header || null
      }))
   })
} 